import React from 'react';
import {Provider} from "react-redux";
import ErrorPage from "../error/ErrorPage";
import {getSafeTranslation} from "../../../helpers/localization.helper";

export const MaintenancePage = ({errorMessage, store}) => {
	return <Provider store={store}>
		<div className="router">
			<ErrorPage
				errorMessage={errorMessage || 'We are unfortunately experiencing problems, contact a waiter to order'}
			/>
		</div>
	</Provider>
}
